import React from 'react';
import { styled } from '@compiled/react';
import CheckIcon from '@atlaskit/icon/glyph/check';
import Spinner from '@atlaskit/spinner';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Status } from '@atlassian/jira-project-create-importer-common';

const SUCCESS_ICON_COLOR = token('color.icon.success', colors.G500);

type Props = {
	status: Status;
	description: string;
};

const getIcon = (status: Status) =>
	status === Status.SUCCESS ? (
		<CheckIcon
			label=""
			primaryColor={SUCCESS_ICON_COLOR}
			size="small"
			testId="project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.check-icon"
		/>
	) : (
		<Spinner
			size="small"
			testId="project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.spinner"
		/>
	);

export const ImportStepProgress = ({ status, description }: Props) => (
	<Wrapper data-testid="project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.wrapper">
		{getIcon(status)}
		<span>{description}</span>
	</Wrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	minHeight: token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		marginLeft: token('space.200', '16px'),
	},
});
